/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Level_NoviceInputs */

const en_us2_exercise_personal_strength_level_novice = /** @type {(inputs: Exercise_Personal_Strength_Level_NoviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novice`)
};

const pt_br2_exercise_personal_strength_level_novice = /** @type {(inputs: Exercise_Personal_Strength_Level_NoviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novato`)
};

const es_419_exercise_personal_strength_level_novice = /** @type {(inputs: Exercise_Personal_Strength_Level_NoviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novato`)
};

const pt_pt2_exercise_personal_strength_level_novice = /** @type {(inputs: Exercise_Personal_Strength_Level_NoviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novato`)
};

const fr_fr2_exercise_personal_strength_level_novice = /** @type {(inputs: Exercise_Personal_Strength_Level_NoviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novice`)
};

const de_de2_exercise_personal_strength_level_novice = /** @type {(inputs: Exercise_Personal_Strength_Level_NoviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novize`)
};

const it_it2_exercise_personal_strength_level_novice = /** @type {(inputs: Exercise_Personal_Strength_Level_NoviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novizio`)
};

/**
* | output |
* | --- |
* | "Novice" |
*
* @param {Exercise_Personal_Strength_Level_NoviceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_level_novice = /** @type {((inputs?: Exercise_Personal_Strength_Level_NoviceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Level_NoviceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_level_novice(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_level_novice(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_level_novice(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_level_novice(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_level_novice(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_level_novice(inputs)
	return en_us2_exercise_personal_strength_level_novice(inputs)
});
export { exercise_personal_strength_level_novice as "exercise-personal.strength_level_novice" }